import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Ananya Das',
    title: "Frontend  Developer",
    desciption:"Debugging is twice as hard as writing the code in the first place.Therfore, if you write the code as cleverly as possible, you are, by definition, not smart enough to debug it.  ",
    // image: 'https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png',
    image:'profile.png',
    resumePdf: resume
}
